<template>
  <tr class="sequence-row selected" @click="$emit('choose-sequence', user.id)">
    <td class="sequence-col">
      <v-icon color="accent" right>
        {{user.selected ? 'bhi-check-circle-filled' : 'bhi-ellipse'}}
      </v-icon>
    </td>
    <td class="sequence-col">
      <h4 class="sequence__name">{{ user.title }}</h4>
      <p v-if="user.exerciseCount && user.dayCount">{{user.dayCount}} day{{user.dayCount > 1 ? 's':''}}  containing {{user.exerciseCount}} {{user.exerciseCount > 1 ? 'activities':'activity'}}</p>
    </td>
    <td class="sequence-col">
      
    </td>
  </tr>
</template>

<script>
export default {
  name: 'SequenceDefinitionTableRow',
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
table {
  min-width: 0 !important;
  width: 100% !important;
}
.sequence {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 54px;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }

    .text-number {
      font-size: 1.125rem;
    }
  }
}
</style>
